var _style, _circle, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,256H512c0-23.1-3.1-45.5-8.8-66.8H244.9V256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.9,122.4h229.6c-15.7-25.6-35.7-48.2-59.1-66.8H244.9V122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c60.2,0,115.6-20.8,159.4-55.7H96.6C140.4,491.2,195.8,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6,389.6h436.9c12.6-20.5,22.3-43,28.8-66.8H8.8C15.2,346.6,25,369,37.6,389.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M118.6,40h23.3l-21.7,15.8l8.3,25.5l-21.7-15.8L85.1,81.3l7.2-22c-19.1,15.9-35.9,34.6-49.7,55.3h7.5l-13.8,10 c-2.2,3.6-4.2,7.2-6.2,10.9l6.6,20.3l-12.3-8.9c-3.1,6.5-5.9,13.1-8.4,19.9l7.3,22.4h26.8l-21.7,15.8l8.3,25.5L15,214.6l-13,9.4 c-1.3,10.5-2,21.1-2,31.9h256c0-141.4,0-158.1,0-256C205.4,0,158.3,14.7,118.6,40z M128.5,230.4l-21.7-15.8l-21.7,15.8l8.3-25.5 l-21.7-15.8h26.8l8.3-25.5l8.3,25.5h26.8l-21.7,15.8L128.5,230.4z M120.2,130.3l8.3,25.5l-21.7-15.8l-21.7,15.8l8.3-25.5l-21.7-15.8 h26.8l8.3-25.5l8.3,25.5h26.8L120.2,130.3z M220.3,230.4l-21.7-15.8l-21.7,15.8l8.3-25.5l-21.7-15.8h26.8l8.3-25.5l8.3,25.5h26.8 L212,204.9L220.3,230.4z M212,130.3l8.3,25.5l-21.7-15.8l-21.7,15.8l8.3-25.5l-21.7-15.8h26.8l8.3-25.5l8.3,25.5h26.8L212,130.3z  M212,55.7l8.3,25.5l-21.7-15.8l-21.7,15.8l8.3-25.5L163.5,40h26.8l8.3-25.5l8.3,25.5h26.8L212,55.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.67e8cbd87e24eacd1d2bbd808421fafb.svg";
export { ForwardRef as ReactComponent };